import { createActionsStructure } from 'services/reduxHelpers'

/* ------------- Action Creators ------------- */

export const { globalTypes, globalActions } = createActionsStructure('global', [
  { name: 'GET_CARRIERS', async: true },
  { name: 'GET_BUSES', async: true },
  { name: 'GET_DRIVERS', async: true },
  { name: 'CREATE_DRIVER', async: true },
  { name: 'SET_DRIVER', async: true },
  { name: 'DELETE_DRIVER', async: true },
  { name: 'CREATE_BUS', async: true },
  { name: 'SET_BUS', async: true },
  { name: 'DELETE_BUS', async: true },
])



// WEBPACK FOOTER //
// ./src/reduxModules/actions/GlobalActions.js